export default "__VITE_ASSET__f9080649__"